<template>
  <div class="list_box">
    <div class="top_box" v-if="flag">
        <span>发布时间 {{list.releaseTime}} </span>
        <span>时长 {{ list.duration }}</span>
    </div>
    <div class="border" v-if="flag || index !== 1"></div>
    <div class="bottom_box">
        <div class="commity">
            <div class="img">
                <div class="index">{{index}}</div>
                <img :src="list.cover">
            </div>
            <div class="text">
                <div class="text_1" @click="goodto(list.goodsLink)"><div class="title">{{ list.caption }}</div></div>
                <div class="text_2" @click="to(list.anchorLink)">
                    <img :src="list.avatar" class="anchor_img">
                    <div class="anchor_name">{{list.name}}</div>
                    <div class="anchor_fans">{{list.fans}} 粉丝</div>
                </div>
                <div class="text_3">
                    <div>播放 {{ list.views }}</div>
                    <div>点赞 {{ list.comments }}</div>
                    <div>评论 {{ list.comments }}</div>
                </div>
            </div>
        </div>
        <div class="commity_bottom" v-if="list.relation" @click="goodto(list.goodsLink)">
            <img src="https://s6.bihukankan.com/img/1693643597Group 4791.svg" alt="" class="icon">
            <div class="text">{{ list.title }}</div>
            <div class="pay">¥ {{list.price}}</div>
        </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props:{
    index:Number,
    info:Object,
    flag:{
        type: Boolean,
        default: true
    }
    },
  data() {
    return {}
  },
  computed:{
    list() {
        return {
            ...this.info,
            cover:this.info?.cover,//视频封面
            title:this.info?.relation?.title || '-',//商品标题
            price:this.info?.relation?.price || '-',//商品价格
            caption:this.info?.caption || '-',//作品标题
            avatar:this.info?.anchor?.avatar,//头像
            name:this.info?.anchor?.name,//头像
            fans:this.info?.anchor?.fans ? this.unit(this.info?.anchor?.fans) : '-',//达人粉丝数
            views: this.info?.views ? this.unit(this.info?.views) : '-',//播放量
            likes: this.info?.likes ? this.unit(this.info?.likes) : '-',//点赞量
            comments: this.info?.comments ? this.unit(this.info?.comments) : '-',//点赞量
            duration: this.info?.duration ? this.Time(this.info?.duration) : '-',//时长
            releaseTime: this.info?.releaseTime ?  moment(this.info?.releaseTime * 1000).format('MM-DD HH:mm') : '-',
            anchorLink: `/anchor/${this.info?.anchor?.id}`,//达人链接
            url: this.info?.url,//作品链接
            goodsLink: `/goods/${this.info?.relation?.itemId}`
        }
    },
  },
  methods: {
    goodto(url) {
        if(this.info?.relation) {
            window.open(url)
        }
    },
    to(url) {
        window.open(url)
    },
    unit(val) {
       const obj = this.$splitWan(val)
       return obj.num + obj.unit
    },
    Time(tiem) {
      const MM =Math.floor(tiem / 60)
      const SS = Math.floor((tiem % 60))
      return `${MM ? MM + '分' : ''}${SS}秒`
    },
  }
}
</script>

<style scoped lang="less">
    .list_box {
        margin-bottom: 12px;
        // height: 217px;
        width: 100vw;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        .top_box {
            height: 42px;
            display: flex;
            align-items: center;
            padding: 0 12px;
            font-size: 12px;
            color: #8E9AAE;
            span {
                margin-right: 36px;
            }
        }
        .border {
            height: 1px;
            background-color:#F2F2F2;
        }
        .bottom_box {
            flex:1;
            padding: 14px 12px;
            .commity {
                display: flex;
                .img {
                    position: relative;
                    width: 66px;
                    height: 90px;
                    border-radius: 4px;
                    overflow: hidden;
                    margin-right: 8px;
                    background-color: #000;
                    img {
                        width: 100%;
                    }
                    .index {
                    background-color: rgba(0, 0, 0,.3);
                    border-radius: 0 2px 2px 0;
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    top: 10px;
                    z-index: 1;
                    color: #fff;
                    font-size: 10px;
                    font-weight: 500;
                    width: 12px;
                    height: 12px;
                }
                }

                .text {
                    display: flex;
                    flex-direction: column;
                    height: 90px;
                    width: 264px;
                    .text_1 {
                        flex: 1;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: flex;
                        align-items: center;
                        font-weight: 500;
                        font-size: 14px;
                        color: #141b27;
                        .title {
                        width: 264px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        }
                    }
                    .text_2 {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        .anchor_img {
                            width: 24px;
                            height: 24px;
                            border-radius: 12px;
                            margin-right: 6px;
                        }
                        .anchor_name {
                            max-width: 114px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            font-size: 14px;
                            color: #252E39;
                            margin-right: 4px;
                        }
                        .anchor_fans {
                            margin-left: 5px;
                            font-size: 14px;
                            color: #999;
                        }
                    }
                    .text_3 {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        div {
                            color: #8E9AAE;
                            font-size: 11px;
                        }
                    }
                }
            }
            .commity_bottom {
                margin-top: 14px;
                display: flex;
                align-items: center;
                padding: 0 0 0 12px;
                height: 36px;
                width: 351px;
                border-radius: 4px;
                background: #FCAD1514;
                .icon {
                    width: 20px;
                    height: 20px;
                    margin-right: 2px;
                }
                .text {
                    font-size: 14px;
                    font-weight: 500;
                    color:#FBA500;
                    width: 226px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    margin-right: 9px;
                }
                .pay {
                    font-size: 14px;
                    color: #FF5000;
                }
            }
        }
    }
</style>
